import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { useAuth } from "@/context/AuthContext";
import { usePageSEO } from "@/hooks/use-seo";

const Login: React.FC = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  usePageSEO("Zoocertica – Admin Login", "Sign in with email and password to access Zoocertica.", "/");

  const submit = async () => {
    setError(null);
    const ok = await login(email, password);
    if (ok) {
      navigate("/admin/facilities", { replace: true });
    } else {
      setError("Invalid credentials. Try admin@zoocertica.com / ZooAdmin1!secure for demo.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Zoocertica Admin</CardTitle>
          <CardDescription>Sign in to continue.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <div>
            <label className="block text-sm mb-1 text-muted-foreground">Email</label>
            <Input placeholder="you@example.com" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="block text-sm mb-1 text-muted-foreground">Password</label>
            <Input placeholder="••••••••" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <div className="text-sm text-destructive">{error}</div>}
          <div className="flex gap-2">
            <Button className="flex-1" onClick={submit}>Login</Button>
          </div>
          <p className="text-xs text-muted-foreground">Demo admin: admin@zoocertica.com / ZooAdmin1!secure</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default Login;
